// extracted by mini-css-extract-plugin
export var footerSection = "index-module--footerSection--rd2hc";
export var footerMenu = "index-module--footerMenu--3J5fh";
export var menuList = "index-module--menuList--v5jRE";
export var link = "index-module--link--3ZHBV";
export var footerContact = "index-module--footerContact--CRhQN";
export var contact = "index-module--contact--1_IYo";
export var mapAspectRatio = "index-module--mapAspectRatio--110oC";
export var map = "index-module--map--1IIiD";
export var footerNav = "index-module--footerNav--3HxXK";